import { StepperRoot } from "./StepperRoot"
import { StepperStep } from "./StepperStep"

export const Stepper = {
  Root: StepperRoot,
  Step: StepperStep
}
